import React from 'react'
import './index.less'
import OrderInfo from '../components/OrderInfo'
import {Button, Col, Input, Row, Empty, message, Spin,} from "antd";
import Goods from "../components/Goods";
import {postSubmit, postCodeInfo} from '@/api/cancelRecord/addNew';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import {isEmpty } from '@utils/utils';
const { TextArea } = Input;

class AddNew extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading:false,
            page: null,
            cancelListStatus: [], // 每款商品登记箱数是否正确
            totalInfo: {
                skuNum: 0,
                quantity: 0,
                normalQuantity: 0,
                damagedQuantity: 0,
            }, // 登记单的信息
            extra: {},
            sCode:'',//进入的订单号
        }
        this.filterForm = React.createRef()
        this.cancelList = [] // 提交客户取消的数据
        this.poId = null
        this.canSubmit = true
    }

    /**
     * 去搜索*/
    handleSearch() {
        let options = this.filterForm.current.getFieldsValue();
        if (!options.orderNumber) {
            message.info(__getServerLanguage('ZhiShaoTianXieYiGeShangPinDengJi'))
        } else {
            postCodeInfo(options).then(res => {
                if (res.data.success && res.data.valid) {
                    this.setState({
                        page: res.data.model,
                        extra: res.data.extra,
                    }, () => {
                        // console.log('this.state.page', this.state.page);
                        if (this.state.page) {
                            let cancelList = this.state.page.goodItemVOS||[]
                            this.poId = this.state.page.id
                            let cancelListStatus = []
                            cancelList&&cancelList.forEach((item, index) => {
                                this.cancelList.push({
                                    damagedNum: 0, //	破损箱数	number
                                    deliveryQuantity: item.quantity, //	原po交付箱数	number
                                    normalNum: 0, // 正常箱数	number
                                    poItemId: item.poItemId, //	PO明细Id	number
                                    remark: '', //	备注	string
                                    skuId: item.skuId, // 商品Id	number
                                })
                                cancelListStatus.push(true)
                                this.setState({
                                    [`normalNum${index}`]: 0,
                                    [`damagedNum${index}`]: 0,
                                })
                            })
                            this.setState({
                                cancelListStatus,
                            })
                        } else {
                            message.info('No data!')
                        }
                    })
                } else {
                    this.setState({
                        page: null,
                    })
                    message.info(res.data.message);
                }
            })
        }
    }

    /**
     * 提交客户取消的数据载入*/
    pushData(index, key, val) {
        if (key == 'remark') {
            this.cancelList[index][key] = val
        } else {
            this.cancelList[index][key] = Number(val||0)

            /*统计登记信息 start*/
            let totalInfo = {
                skuNum: 0,
                quantity: 0,
                normalQuantity: 0,
                damagedQuantity: 0,
            }
            this.cancelList.forEach(item => {
                if (item.damagedNum||item.normalNum) {
                    totalInfo.skuNum += 1
                }
                totalInfo.normalQuantity += item.normalNum
                totalInfo.damagedQuantity += item.damagedNum
            })
            totalInfo.quantity = totalInfo.normalQuantity + totalInfo.damagedQuantity
            this.setState({
                totalInfo,
            })
            /*统计登记信息 end*/
        }
    }

    /**
     * 提交客户取消*/
    toSubmit() {
        let isOk = true
        // console.log('this.cancelList', this.cancelList);
        const cancelListStatus = []
        const cancelList = []
        this.cancelList.forEach((item, index) => {
            if (item.damagedNum+item.normalNum>item.deliveryQuantity) {
                isOk = false
                cancelListStatus.push(false)
            } else {
                cancelListStatus.push(true)
            }

            // 只提交登记箱数大于0的
            if (item.damagedNum || item.normalNum) {
                cancelList.push(item)
            }
        })
        this.setState({
            cancelListStatus,
        })
        if (!isOk) {
            message.info(__getServerLanguage('DengJiZongXiangShuBuNengDaYuDingDanShangPinShu'))
        } else {
            if (this.canSubmit&&cancelList.length>0) {
                this.canSubmit = false
                const Timeout = 2000
                postSubmit({
                    cancelList,
                    poId: this.poId,
                }).then(res => {
                    if (res.data.success && res.data.valid) {
                        message.success(__getServerLanguage('XinZengChengGong'))
                        setTimeout(() => {
                            this.props.history.goBack()
                        }, Timeout)
                    } else {
                        message.info(res.data.message);
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.canSubmit = true
                    }, Timeout)
                })
            } else {
                message.info(__getServerLanguage('QingTianXieYaoQuXiaoShangPinDeXiangShu'))
            }
        }
    }
    getCode(str){
        let sCode = str.length>0?str.substr(1,str.length):'';
        this.setState({
            sCode: sCode
        })
        return sCode;
    }
    getDetail(sCode){
        if(!isEmpty(sCode)){

            const options = {
                orderNumber:sCode
            }
            postCodeInfo(options).then(res => {
                if (res.data.success && res.data.valid) {
                    this.setState({
                        page: res.data.model,
                        extra: res.data.extra,
                    }, () => {
                        if (this.state.page) {
                            let cancelList = this.state.page.goodItemVOS||[]
                            this.poId = this.state.page.id
                            let cancelListStatus = []
                            cancelList&&cancelList.forEach((item, index) => {
                                this.cancelList.push({
                                    damagedNum: 0, //	破损箱数	number
                                    deliveryQuantity: item.quantity, //	原po交付箱数	number
                                    normalNum: 0, // 正常箱数	number
                                    poItemId: item.poItemId, //	PO明细Id	number
                                    remark: '', //	备注	string
                                    skuId: item.skuId, // 商品Id	number
                                })
                                cancelListStatus.push(true)
                                this.setState({
                                    [`normalNum${index}`]: 0,
                                    [`damagedNum${index}`]: 0,
                                })
                            })
                            this.setState({
                                cancelListStatus,
                            })
                        } else {
                            message.info('No data!')
                        }
                    })
                } else {
                    this.setState({
                        page: null,
                    })
                    message.info(res.data.message);
                }
            })
        }

    }
    componentDidMount() {
        const { search } = this.props.location;
        const sCode = this.getCode(search);
        this.getDetail(sCode);
    }

    render() {
        const {page, cancelListStatus=[], extra, totalInfo, loading,sCode} = this.state;
        const pageName = Lang({id: "PoDanLieBiao",default: "订单列表"});
        return (<Spin tip='loading' spinning={loading}>
            <CommonBreadcrumb list={[{ name:pageName,link:'/order/sale'},{name:sCode}]}></CommonBreadcrumb>
            <div className="cancelRecord-addNew">
                {/*<p className="font-title fw_500 font_15 mb_16 lineH_22">{__getServerLanguage('XinZengDengJi')}</p>*/}

                {/*<div className="filter-box">*/}
                    {/*<Form className="input-form mb_16" ref={this.filterForm} layout="inline">*/}
                        {/*<Form.Item*/}
                            {/*label={__getServerLanguage("DengJiDanHao")}*/}
                            {/*name="orderNumber"*/}
                        {/*>*/}
                            {/*<Input placeholder={__getServerLanguage('DingDanHao')}/>*/}
                        {/*</Form.Item>*/}

                        {/*<Form.Item>*/}
                            {/*<Button type="primary" onClick={this.handleSearch.bind(this)}>*/}
                                {/*{__getServerLanguage("SouSuo")}*/}
                            {/*</Button>*/}
                        {/*</Form.Item>*/}
                    {/*</Form>*/}
                {/*</div>*/}


                {!page&&(
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                           description={<span>{__getServerLanguage('QingXianShuRuDingDanHaoChaXun')}</span>}/>
                )}

                {page&&(
                    <div key={this.poId}>
                        {/*key发生变化，这个div会全部重新渲染，解决input不绑value值引起的缓存*/}
                        <div className="mb_16">
                            <OrderInfo info={page}/>
                        </div>

                        <div className="details-con">
                            <div className="con-th">
                                <Row>
                                    <Col span={10}>{__getServerLanguage('ShangPinXinXi')}</Col>
                                    <Col span={4}>{__getServerLanguage('XiangShu')}</Col>
                                    <Col span={10}>{__getServerLanguage('CaoZuo')}</Col>
                                </Row>
                            </div>

                            <div className="con-tb mb_24">
                                {page.goodItemVOS&&page.goodItemVOS.map((item, index) => (
                                    <Row key={index.toString()}>
                                        <Col span={10}>
                                            <Goods data={item} currencySymbol={extra.currencySymbol}></Goods>
                                        </Col>
                                        <Col span={4}>
                                            <p className="font-title font_13 mt_16 lineH_19">
                                                x {item.quantity}
                                            </p>
                                        </Col>
                                        <Col span={10}>
                                            <div className="mt_16 fw_500 font-title lineH_19 font_13">
                                                {/*<div className="input-box mr_30 mb_16" data-flex="cross:center">*/}
                                                    <Row className="mt_16">
                                                    <Col span={8}>{__getServerLanguage('ZhengChangDengJi')}</Col>
                                                    <Col span={16}>
                                                    <Input style={{width: '240px', border: cancelListStatus[index]?'none':'1px solid red',}}
                                                           type='number'
                                                           min={0}
                                                           value={this.state[`normalNum${index}`]}
                                                           onChange={(e) => {
                                                               let val = e.target.value.replace(/[^0-9]/g, '')
                                                               // console.log(val);
                                                               this.setState({
                                                                   [`normalNum${index}`]: val,
                                                               })
                                                               this.pushData(index, 'normalNum', val)
                                                           }}
                                                           addonAfter={__getServerLanguage('WaiXiang')}/>
                                                    </Col>
                                                    </Row>
                                                {/*</div>*/}

                                                <Row className="mt_16">
                                                    <Col span={8}>{__getServerLanguage('PoSunDengJi')}</Col>
                                                    <Col span={16}>
                                                        <Input style={{width: '240px', border: cancelListStatus[index]?'none':'1px solid red',}}
                                                               type='number'
                                                               min={0}
                                                               value={this.state[`damagedNum${index}`]}
                                                               onChange={(e) => {
                                                                   let val = e.target.value.replace(/[^0-9]/g, '')
                                                                   // console.log(val);
                                                                   this.setState({
                                                                       [`damagedNum${index}`]: val,
                                                                   })
                                                                   this.pushData(index, 'damagedNum', val)
                                                               }}
                                                               addonAfter={__getServerLanguage('WaiXiang')} />
                                                    </Col>
                                                </Row>

                                                <Row className="mt_16 mb_16">
                                                    <Col span={8}>{__getServerLanguage('BeiZhu')}</Col>
                                                    <Col span={16}>
                                                        <TextArea onChange={(e) => {
                                                            this.pushData(index, 'remark', e.target.value)
                                                        }}
                                                                  style={{flex: '1',}} rows={4} />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                ))}

                            </div>

                            <div className="con-register mb_16" data-flex="dir:top cross:center">
                                <p className="font_16 fw_500 font-title mb_16">
                                    {/*合计：总共 ? 款，总共 ? 箱（正常登记：?箱，破损登记： ? 箱）*/}
                                    {__getServerLanguage('HeJi')}：
                                    {__getServerLanguage('ZongGong')} <span className="font-main">{totalInfo.skuNum}</span> {__getServerLanguage('Kuan')}，
                                    {__getServerLanguage('ZongGong')} <span className="font-main">{totalInfo.quantity}</span> {__getServerLanguage('Xiang')}
                                    （{__getServerLanguage('ZhengChangDengJi')}：<span className="font-main">{totalInfo.normalQuantity}</span>{__getServerLanguage('Xiang')}，
                                    {__getServerLanguage('PoSunDengJi')}：<span className="font-main">{totalInfo.damagedQuantity}</span>{__getServerLanguage('Xiang')}）
                                </p>

                                <Button type="primary"
                                        onClick={this.toSubmit.bind(this)}
                                        shape="round"
                                        size="large">
                                    {__getServerLanguage('ShengChengDengJiDan')}
                                </Button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </Spin>)
    }
}

AddNew.defaultProps = {

}

export default AddNew
